import { Controller } from 'stimulus'

import Rails from '@rails/ujs'
import axios from 'axios'

export default class extends Controller {
  static targets = ['customerList', 'items', 'paymentAmount']

  connect() {
    axios.defaults.headers.common['X-CSRF-Token'] = Rails.csrfToken()

    if (this.hasItemsTarget) {
      this.itemsTarget.querySelectorAll('input.input-sku')[0].focus()
    }
  }

  addPaymentRow() {
    const amountInputs = this.paymentAmountTargets.filter(input => input.closest('.form-row').style.display !== 'none')

    if (amountInputs.length === 0) { return }

    const newAmountInput = amountInputs[amountInputs.length - 1]
    const enteredAmount = amountInputs.slice(0, -1).reduce((sum, input) => sum + this.parseAmount(input.value), 0)
    const remainingAmount = Math.max(this.totalAmount() - enteredAmount, 0)

    newAmountInput.value = this.formatAmount(remainingAmount)
  }

  chooseCustomer() {
    const {
      actionsUrl,
      itemsUrl
    } = event.currentTarget.dataset

    const checkoutActions = document.getElementById('checkout_actions')
    const checkoutItems = document.getElementById('checkout_items')

    checkoutActions.src = actionsUrl
    if (checkoutItems.src == null) { checkoutItems.src = itemsUrl }
  }

  formatAmount(amount) {
    return amount.toFixed(2).replace('.', ',')
  }

  parseAmount(value) {
    return parseFloat(value.replace(/\./g, '').replace(',', '.')) || 0
  }

  preventSubmit() {
    if (event.key == 'Enter') {
      event.preventDefault()
    }
  }

  searchCustomer() {
    const searchQuery = event.currentTarget.value

    if (searchQuery) {
      const baseUrl = event.currentTarget.dataset.updateUrl
      const separator = baseUrl.includes('?') ? '&' : '?'

      this.customerListTarget.src = `${baseUrl}${separator}search=${searchQuery}`
    }
  }

  totalAmount() {
    const totalElement = this.element.querySelector('.invoicing__totals__grand-total strong')

    if (!totalElement) { return 0 }

    return this.parseAmount(totalElement.textContent.replace(/[^\d,.-]/g, ''))
  }
}
